import moment from "moment";

export const getHistories = async (props, filters) => {
  const { apiUrl, token } = props;
  let { startDate, endDate, eventType, assetType } = filters;

  // convert time to UTC time, e.g., if EST time add four hours, since events are stored in UTC / greenwich mean time in the database. This endpoint takes YYYYMMDD format only.
  startDate = moment(startDate).startOf("day").utc().format("YYYYMMDD");
  endDate = moment(endDate).endOf("day").utc().format("YYYYMMDD");
  let headers = new Headers();
  headers.append("auth-token", token);
  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  let histories =
    (await fetch(
      `${apiUrl}assetHistories/events/${
        eventType ? eventType : "origin"
      }?startDate=${startDate}&endDate=${endDate}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        return result.recentScans;
      })
      .catch((error) => console.log("error", error))) || [];

  if (histories.length && assetType && assetType !== "No Units of Measure") {
    return histories.filter((scan) => {
      return scan.assetType === assetType;
    });
  } else {
    return histories;
  }
};

export const getAssetById = async (props, assetId) => {
  const { apiUrl, token } = props;
  let headers = new Headers();
  headers.append("auth-token", token);
  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  let asset =
    (await fetch(`${apiUrl}assets/${assetId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => console.log(error))) || [];

  return asset.asset;
};

export const getProductScans = async (props, filters) => {
  const { apiUrl, token } = props;
  const productId = filters.product.value;
  let { startDate, endDate } = filters;

  // convert time to UTC time, e.g., if EST time add four hours, since events are stored in UTC / greenwich mean time in the database. This endpoint takes YYYYMMDD format only.
  startDate = moment(startDate).startOf("day").utc().format("YYYYMMDD");
  endDate = moment(endDate).endOf("day").utc().format("YYYYMMDD");

  let myHeaders = new Headers();

  myHeaders.append("auth-token", token);
  myHeaders.append("Content-Type", "application/json");

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  let scans =
    (await fetch(
      `${apiUrl}products/${productId}/events/scan?startDate=${startDate}&endDate=${endDate}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        return result.assetHistories;
      })
      .catch((error) => console.log("error", error))) || [];

  return scans;
};

export const CreateEventTrigger = async (
  props,
  trackedEvent,
  event,
  repeat = "all"
) => {
  const { apiUrl, userId, token } = props;
  const { id, type } = trackedEvent;

  const body = {
    name: `${id} - ${event}`,
    note: `Tracking ${id} for event ${event}`,
    triggerMap: {
      event,
      repeat,
    },
    notificationMap: {
      email: [userId],
    },
  };

  switch (type) {
    case "batch":
      body.triggerMap.batchId = id;
      break;
    case "product":
      body.triggerMap.productId = id;
      break;
    case "asset tag":
      body.triggerMap.assetIds = [id];
      break;
    case "asset category":
      body.triggerMap.category = id;
      break;
    default:
      break;
  }

  const response = await fetch(`${apiUrl}eventTriggers/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
    body: JSON.stringify(body),
  })
    .then((response) => response.json())
    .then((response) => {
      return response.eventTrigger;
    });
  return response;
};

export const EditUserNotification = async (
  props,
  userNotificationId,
  status
) => {
  const { apiUrl, token } = props;
  const body = {
    status,
  };
  const response = await fetch(
    `${apiUrl}userNotifications/${userNotificationId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
      body: JSON.stringify(body),
    }
  )
    .then((response) => response.json())
    .then((response) => {
      return response;
    });

  return response;
};

export const DeleteEventTrigger = async (props, eventTrigerId) => {
  const { apiUrl, token } = props;

  const response = await fetch(`${apiUrl}eventTriggers/${eventTrigerId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  })
    .then((response) => response.json())
    .then((response) => {
      return response;
    });

  return response;
};

export function RetrieveAssetHistorysByEvent(props, callback) {
  const { apiUrl, currentDate, event, rangeOfMonths, token } = props;
  // Grabs the first month from the range specified
  const firstMonth = moment(currentDate)
    .subtract(rangeOfMonths, "month")
    .utc()
    .format("YYYYMM");

  // Grabs the last month from the range specified
  const lastMonth = moment(currentDate)
    .subtract(1, "month")
    .utc()
    .format("YYYYMM");

  // Grabs the last day of specified month in the range specified
  const lastMonthsDaysCount = moment(lastMonth, "MMM YYYY").daysInMonth();

  // If ranges are not provided, the /api/assetHistories/events/{event} endpoint is called

  const queryParams =
    currentDate !== undefined && rangeOfMonths !== undefined
      ? `?startDate=${firstMonth}01&endDate=${lastMonth}${lastMonthsDaysCount}`
      : "";

  fetch(`${apiUrl}assetHistories/events/${event}${queryParams}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "auth-token": token,
    },
  })
    .then((res) => res.json())
    .then((res) => res.recentScans)
    .catch((err) => {
      console.log("error: " + err.message + " " + err.response);
    });  
 
}
